import { render, staticRenderFns } from "./storage-save.vue?vue&type=template&id=2cc6ef51"
import script from "./storage-save.vue?vue&type=script&lang=js"
export * from "./storage-save.vue?vue&type=script&lang=js"
import style0 from "./storage-save.vue?vue&type=style&index=0&id=2cc6ef51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports